import React, { useContext } from 'react';

import { api } from '../api';
import { IntercomApi } from '../apis/intercom';

const IntercomApiContext = React.createContext(new IntercomApi(api));

export const IntercomApiProvider = IntercomApiContext.Provider;
export const useIntercomApi = (): IntercomApi => useContext(IntercomApiContext);
